import React from 'react'
import { useParams } from 'react-router-dom';
import { useCurrentOnwer } from '../../../hooks/owner/owner';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import OwnerDetailsCard from '../../../components/admin/owner/OnwerDetailsCard';
import Layout from '../../../components/layouts/Layout';
import { useStoresByOnwer } from '../../../hooks/owner/allStores.owner';
import MainTitle from '../../../components/ui/MainTitle';
import StoreAdminBox from '../../../components/admin/stores/StoreBoxAdmin';
import EmptyData from '../../../components/ui/EmptyData';
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useTranslation } from 'react-i18next';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function OnwerDetailsPageForAdmin() {
    const { ownerId} = useParams<{ ownerId: string}>();
   const numericOwnerId = ownerId ? parseInt(ownerId) : 0;
   const {data:owner,isError:errorOwner,isLoading:loadingOwner} = useCurrentOnwer(numericOwnerId);
   const {data:stores , isError , isLoading} = useStoresByOnwer(numericOwnerId);
   const {t}  = useTranslation();
  return (
    <Layout headline='' title=''>
        <LoadingErrorState
        isError={errorOwner}
        isLoading={loadingOwner}
        />
        {
            owner && <OwnerDetailsCard owner={owner}/>
        }
        <div className=' mt-6'>
            <div className='flex justify-between mb-6'>
                <MainTitle title='stores'/>
                <div className="flex items-center gap-3">
                    {/* Hint – show only when condition is true */}
                    {stores?.hasIncompleteStore && (
                    <span className="text-sm text-yellow-600 bg-yellow-100 px-3 py-1 rounded-lg border border-yellow-200">
                        {t('hasIncompleteStoreOwner')}
                    </span>
                    )}

                    <PermissionGate permissions={[PermissionsKey.CreateStore]}>
                        <PrimaryButtonWithIconAdd
                        buttonLabel="add_new_store"
                        buttonLinkPath={`/admin/owners/${ownerId}/add-store`}
                        />
                    </PermissionGate>
                </div>
            </div>
            <LoadingErrorState
                isError={isError}
                isLoading={isLoading}
                type="grid"
            />
            {
                stores &&
                <div>
                    {
                        stores.stores.length===0 ? <EmptyData/> :
                        <div className='grid md:grid-cols-2 xl:grid-cols-3 gap-8 mt-8'>
                            {
                                stores.stores.map(st=>{
                                return <StoreAdminBox key={st.id+"demk"} store={st} />
                                })
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </Layout>
  )
}

export default OnwerDetailsPageForAdmin